import { gql } from 'graphql-tag'
import { orderFieldsCMA } from './orderFieldsCMA'

export const EDIT_ORDER = gql`
  mutation editOrder($orderId: String, $addressInput: NewAddressInput) {
    editOrder(orderId: $orderId, addressInput: $addressInput) {
      ...OrderFieldsCMA
    }
  }
  ${orderFieldsCMA}
`
